let _showFn = null;
let _pendingTrigger = false;

export function registerShowSessionExpiredModal(fn) {
  _showFn = fn;

  if (_pendingTrigger) {
    _showFn();
    _pendingTrigger = false;
  }
}

export function triggerSessionExpiredModal() {
  if (window.__SUPPRESS_SESSION_MODAL__) return;
  if (typeof _showFn === "function") {
    _showFn();
  } else {
    _pendingTrigger = true; 
    console.warn(
      "[sessionExpired] triggerSessionExpiredModal chamado mas não há showFn registrada."
    );
  }
}
